<template>
    <banner-description
      title="naviVaccination.naviVaccinationChild"
      titleColor="#603813"
      :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
      :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleLeft', imgFormat: 'svg', position: 'top: 0%' }"
      :imgObj="{ componentName: 'naviVaccination', imgName: 'vacChild', imgFormat: 'svg' }"
      description="naviVaccination.naviVaccinationChildDesc"
      descColor="#4E4E4E"
      class="pb-24"
    />
  </template>
  
  <script setup lang="ts">
  import { useVaccinationStore } from "@/stores/naviVaccination";
  import { computed, onMounted, ref, toRefs } from "vue";
  import { useRouter } from "vue-router";
  import { useI18n } from "vue-i18n";
  
  const vaccinationStore = useVaccinationStore();
  const router = useRouter();
  const { t, locale } = useI18n();
  
  onMounted(async () => {});
  
  //not on home page, stop intro timer
  router.beforeEach(async (to, from) => {});
  
  const goTo = (refName) => {};
  
  const routeTo = (position) => {
    router.push({ name: position, params: { uid: "lczmx" } });
  };
  </script>